import Network from '../../lib/network/network'
import gettEnv from '../../config/gettEnv'

const gatewayUrl = gettEnv.DELIVERY_GATEWAY_HOSTNAME
const baseUrl = `${gatewayUrl}/api/v1/public`
const network = new Network(baseUrl)

export const validateRating = (token: string) => {
  return network.get(`/rating/${token}/validate`)
}

export const sendRating = (token: string, rating: number) => {
  return network.post(`/rating/${token}`, {
    rating,
  })
}
